import React from 'react';

import CodeMirrorPreview from '@dashboard/components/CodeMirror/CodeMirrorPreview';
import LoadingIndicator from '@dashboard/components/loading/LoadingIndicator';
import { useEmailMessageQuery } from '@dashboard/generated/wp/platform';

import RenderError from './RenderError';

type Props = {
  waypointEventId: string;
};
export default function HtmlPanel({ waypointEventId }: Props) {
  const { data } = useEmailMessageQuery({ variables: { id: waypointEventId } });

  const renderPreview = () => {
    const model = data?.EmailMessage;
    if (model === undefined) {
      return <LoadingIndicator />;
    }
    return <CodeMirrorPreview key={waypointEventId} language="HTML" value={model.message.bodyHtml ?? ''} />;
  };

  return (
    <>
      <RenderError waypointEventId={waypointEventId} />
      {renderPreview()}
    </>
  );
}
